import { render, staticRenderFns } from "./pdfread.vue?vue&type=template&id=0b074948&scoped=true&"
import script from "./pdfread.vue?vue&type=script&lang=js&"
export * from "./pdfread.vue?vue&type=script&lang=js&"
import style0 from "./pdfread.vue?vue&type=style&index=0&id=0b074948&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b074948",
  null
  
)

export default component.exports